/**
 * @description Константы для высоты аннотации по процентам
 */
export var EMortgageAnnotationHeightPercent = /*#__PURE__*/function (EMortgageAnnotationHeightPercent) {
  EMortgageAnnotationHeightPercent[EMortgageAnnotationHeightPercent["Default"] = 6] = "Default";
  EMortgageAnnotationHeightPercent[EMortgageAnnotationHeightPercent["Half"] = 3] = "Half";
  EMortgageAnnotationHeightPercent[EMortgageAnnotationHeightPercent["Double"] = 12] = "Double";
  return EMortgageAnnotationHeightPercent;
}({});

/**
 * @description Константы для высоты аннотации по процентам до единицы
 */
export var MortgageAnnotationHeightPercentDecimal = /*#__PURE__*/function (MortgageAnnotationHeightPercentDecimal) {
  MortgageAnnotationHeightPercentDecimal[MortgageAnnotationHeightPercentDecimal["Default"] = 0.06] = "Default";
  MortgageAnnotationHeightPercentDecimal[MortgageAnnotationHeightPercentDecimal["Half"] = 0.03] = "Half";
  MortgageAnnotationHeightPercentDecimal[MortgageAnnotationHeightPercentDecimal["Double"] = 0.12] = "Double";
  return MortgageAnnotationHeightPercentDecimal;
}({});